
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.76 46.32h6.74V30H37l.6-5.62h-5.1v-2.82c0-1.47.14-2.25 2.24-2.25h2.81v-5.63h-4.5c-5.41 0-7.31 2.73-7.31 7.32v3.38H22.4V30h3.37v16.32zM30 60a30 30 0 1130-30 30 30 0 01-30 30z"}})])
          )
        }
      }
    